import { defineStore } from 'pinia'

export const useCommonStore = defineStore('CommonStore', {
  state: () => {
    return {
      windowInnerWidth: window.innerWidth,
    }
  },
  actions: {
    updateWindowWidth(width) {
      this.windowInnerWidth = width
    },
  },
})
